<template>
    <div>
        <v-img
            class="mx-auto mb-2"
            :src="image.value"
            v-if="image"
            max-height="200"
            max-width="200"
        />
        <psi-simple-table
            :headers="headers"
            :items="details"
            dense
        ></psi-simple-table>
    </div>
</template>

<script>
export default {
    name: "case-details-list",
    props: {
        caseDetails: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            headers: [
                {
                    title: "Field",
                    class: "text-left",
                    key: "label",
                    width: 200,
                },
                {
                    title: "Value",
                    class: "text-left",
                    key: "value",
                    width: 140,
                },
            ],
        };
    },
    computed: {
        image() {
            return this.details.find(
                (item) => item.label.toLowerCase() === "image"
            );
        },
        details() {
            return Object.keys(this.caseDetails)
                .map((key) => {
                    return {
                        label: this.$_.startCase(key),
                        value: this.caseDetails[key] ?? "",
                    };
                })
                .filter((item) => item.value.length > 0)
                .sort((a, b) => a.label > b.label);
        },
    },
};
</script>
